interface ShapeOptions {
  borderRadius: number;
  borderRadiusSm: number;
  borderRadiusMd: number;
}
export const shape: ShapeOptions = {
  borderRadius: 16,
  borderRadiusSm: 12,
  borderRadiusMd: 16,
};
